var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7011 1.48662C23.7777 1.12732 25.8544 0.7679 28.0002 0.396484C27.5944 2.51517 27.1946 4.60273 26.7818 6.75878C26.3988 6.37649 26.0247 6.04187 25.6994 5.66445C25.4716 5.40035 25.3302 5.45458 25.1158 5.66604C23.7638 7.00035 22.4033 8.32628 21.0441 9.65358C18.6185 12.0226 16.1885 14.3875 13.771 16.7647C13.5691 16.9631 13.4685 16.9312 13.2887 16.7585C12.2742 15.7848 11.2437 14.8276 10.2324 13.8508C10.0352 13.6607 9.93094 13.6461 9.72797 13.851C7.50706 16.0876 5.27245 18.3106 3.05142 20.5464C2.8489 20.7513 2.74204 20.7856 2.52379 20.5606C1.87967 19.896 1.21064 19.255 0.541503 18.615C0.393661 18.4734 0.394114 18.3956 0.540484 18.2504C3.65626 15.1576 6.76988 12.0623 9.87264 8.95625C10.0929 8.73596 10.1902 8.87169 10.3268 9.00086C11.3313 9.95017 12.3393 10.8962 13.3335 11.8564C13.497 12.0147 13.5703 12.0024 13.7268 11.8512C16.4943 9.17983 19.2693 6.51573 22.0427 3.85028C22.2854 3.61731 22.518 3.37143 22.7789 3.16042C23.0125 2.97149 22.9694 2.84583 22.7689 2.66743C22.3776 2.31865 22.0054 1.94848 21.6257 1.58726C21.6508 1.55397 21.6763 1.52047 21.7011 1.48662Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashIcon);
export default __webpack_public_path__ + "static/media/flash-icon.036eb0eebe6a088c8d26c668f5620fa7.svg";
export { ForwardRef as ReactComponent };